// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"653":"9f056d91","2404":"a07db939","3318":"1fc1e266","4098":"1fc1e266","5389":"1fc1e266","5910":"1fc1e266","7279":"1fc1e266","7578":"628740ab","9275":"1fc1e266"}[chunkId] + ".chunk.css";
};